import { List, ListSubheader } from "@material-ui/core";
import React, { useMemo } from "react";

import FileItem from "./FileItem";
import TextItem from "./TextItem";
import useDocs from "./useDocs";
import { useTranslate } from "react-admin";

const Docs = ({
  record,
  filter,
  title = "resources.research-projects.fields.docs",
  maxWidth = 250,
}) => {
  const translate = useTranslate();
  const allDocs = useDocs(record, translate);
  const docs = useMemo(
    () => (filter ? allDocs.filter(filter) : allDocs),
    [filter, allDocs]
  );
  return (
    <List>
      <ListSubheader>{translate(title)}</ListSubheader>
      {docs.length === 0 && (
        <TextItem
          value={translate("resources.research-projects.docs.empty")}
          maxWidth={maxWidth}
        />
      )}
      {docs.map((doc, index) => (
        <FileItem key={index} button {...doc} maxWidth={maxWidth} />
      ))}
    </List>
  );
};

export default Docs;
